import { registerClass } from '../SatCoreRegistry';

import { generateRobustUrl } from '../utils/url';

export default class LoginService {
  /**
   * Append runtime params to a login external-resource URL via `urlParamKeys`.
   * @param {{ url?: string, urlParamKeys?: string[] }} resourceUrlObj
   * @returns {string | null} The (possibly decorated) URL, or `null` if no usable URL.
   */
  static appendLoginExternalResourceUrlParams = (resourceUrlObj) => {
    const url = resourceUrlObj?.url;
    if (typeof url !== 'string') {
      return null;
    }
    const urlParamKeys = resourceUrlObj?.urlParamKeys;
    if (!Array.isArray(urlParamKeys) || !urlParamKeys.length) {
      return url;
    }
    const urlParamValues = {};
    for (const key of urlParamKeys) {
      // No login external resource urlParamKeys wired up yet - add cases here as needed.
      // See `TopNavService.appendTopNavExternalResourceUrlParams` for an example implementation.
      let urlParamValue;
      switch (key) {
        default:
          console.warn(`appendLoginExternalResourceUrlParams: unknown key "${key}"`);
      }
      if (typeof urlParamValue === 'string') {
        urlParamValues[key] = urlParamValue;
      }
    }
    if (!Object.keys(urlParamValues).length) {
      return url;
    }
    try {
      return generateRobustUrl(url, urlParamValues);
    } catch (error) {
      console.warn('appendLoginExternalResourceUrlParams: invalid URL', url, error);
      return url;
    }
  }
}

registerClass('LoginService', LoginService);
